// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  V1_apiUrl: 'https://api-v1-dev.pplplus.org',
  V1_RapiUrl: 'https://api-v1-dev.pplplus.org',
  V1_R2apiUrl: 'https://api-v1-dev.pplplus.org',
  
  V2_apiUrl: 'https://api-v2-dev.pplplus.org',
  V2_RapiUrl: 'https://api-v2-dev.pplplus.org',
  V2_R2apiUrl: 'https://api-v2-dev.pplplus.org' 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
